import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.css';
import './themes/generated/theme.additional.css';
import { createApp }  from "vue";
import router from "./router";

import App from "./App";
import appInfo from "./app-info";
import NYParameters from '../ny-globals';
import VueGoogleMaps from '@fawmi/vue-google-maps'

const app = createApp(App);
app.use(router);
app.use(VueGoogleMaps, {
    load: {
        key: NYParameters.googleMapsAPIKey,
        // language: 'de',
    },
})
app.config.globalProperties.$appInfo = appInfo;
app.mount('#app');

// Example of demo application from
//https://js.devexpress.com/Documentation/Guide/Vue_Components/Application_Template/
